<div class="box box-info">
  <div class="box-header with-border">
    <h3 class="box-title">Delete Beneficiary</h3>
  </div>
  <!-- /.box-header -->
  <!-- form start -->
  <form class="form-horizontal" role="form" [formGroup]="form" novalidate>
    <div class="box-body">
      <div class="form-group">
        <label class="col-sm-3 control-label">Choose beneficiary</label>

        <div class="col-sm-9">
          @if (beneficiaries) {
            <select
              class="form-control"
              formControlName="id"
              >
              <option value="">select a Beneficiary</option>
              @for (item of beneficiaries; track item) {
                <option value="{{ item.id }}">{{
                  item.title
                }}</option>
              }
            </select>
          }
          @if (
            form.controls['id'].hasError('required') &&
            (form.controls['id'].touched || attemptedSubmit)
            ) {
            <control-message
              message="Beneficiary is required."
            ></control-message>
          }
        </div>
      </div>
    </div>
    <!-- /.box-body -->
    <div class="box-footer">
      <div class="box-footer">
        <button
          type="button"
          (click)="submitForm()"
          class="btn btn-danger pull-right"
          >
          Delete Beneficiary
        </button>
      </div>
    </div>
    <!-- /.box-footer -->
  </form>
</div>
